export default __webpack_public_path__ + "d0beb71864198eb3f37dc895bed7ee52.svg";